// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.progress {
  display: flex;
  justify-content: space-evenly;
}
.progress ion-progress-bar {
  z-index: 3;
  --background: rgba(255, 255, 255, 0.6);
  --progress-background: white;
  margin: 4px;
  border-radius: 8px;
}

ion-content {
  --background: black;
}

.shadow {
  box-shadow: inset 0px 18px 21px -4px rgba(0, 0, 0, 0.75);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  width: 200%;
  height: 10vh;
}

.page-wrapper {
  padding-top: env(safe-area-inset-top);
}

ion-content::part(background) {
  padding-top: env(safe-area-inset-top);
}

.detail-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  gap: 1rem;
  text-align: center;
}
.detail-wrapper img {
  max-height: 50vh;
}
.detail-wrapper .title {
  font-weight: bold;
  font-size: 18px;
}
.detail-wrapper .text {
  padding: 1rem;
  overflow: auto;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  z-index: 3;
  color: white;
  width: 2rem;
  height: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/news-detail/news-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,6BAAA;AACJ;AAAI;EACI,UAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;AAER;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,wDAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE,iBAAA;EACA,eAAA;AAEJ;AAAE;EACE,aAAA;EACA,cAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AACF","sourcesContent":[".img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n}\n\n.progress{\n    display: flex;\n    justify-content: space-evenly;\n    ion-progress-bar {\n        z-index: 3;\n        --background: rgba(255, 255, 255, 0.6);\n        --progress-background: white;\n        margin: 4px;\n        border-radius: 8px;\n      }\n}\n\nion-content {\n  --background: black;\n}\n\n.shadow {\n  box-shadow: inset 0px 18px 21px -4px rgba(0, 0, 0, 0.75);\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  width: 200%;\n  height: 10vh;\n}\n\n.page-wrapper{\n  padding-top: env(safe-area-inset-top);\n}\n\nion-content::part(background){\n  padding-top: env(safe-area-inset-top);\n}\n\n.detail-wrapper{\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: white;\n  gap: 1rem;\n  text-align: center;\n  img{\n    max-height: 50vh;\n  }\n  .title{\n    font-weight: bold;\n    font-size: 18px;\n  }\n  .text{\n    padding: 1rem;\n    overflow: auto;\n  }\n}\n\n.close-btn{\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  cursor: pointer;\n  z-index: 3;\n  color: white;\n  width: 2rem;\n  height: 2rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
